import PersonalTeacherDataForm from './PersonalTeacherDataForm';

export default PersonalTeacherDataForm;
